"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APForm = exports.APFormContext = void 0;
var react_1 = __importDefault(require("react"));
exports.APFormContext = react_1.default.createContext(undefined);
function APForm(props) {
    return (react_1.default.createElement(exports.APFormContext.Provider, { value: props.control },
        react_1.default.createElement("form", { onSubmit: function (event) { props.control.submit(); event === null || event === void 0 ? void 0 : event.preventDefault(); }, style: props.style }, props.children)));
}
exports.APForm = APForm;
